import IFStationsMap from 'Containers/IFStationsMap/IFStationsMap'
const StationsMapPage = () => {
  return <IFStationsMap height="100%" width="100%" />
}

export default StationsMapPage
